import React from 'react';
import { Route } from 'react-router-dom';
import AddStock from '@/pages/inventory/AddStock';
import IssueStock from '@/pages/inventory/IssueStock';
import StockReport from '@/pages/inventory/StockReport';
import StockUseReport from '@/pages/inventory/StockUseReport';
import SuppliersEntry from '@/pages/inventory/SuppliersEntry';
import PurchaseOrder from '@/pages/inventory/PurchaseOrder';
import ReceiveItem from '@/pages/inventory/ReceiveItem';
import PaySuppliers from '@/pages/inventory/PaySuppliers';
import InventoryLedger from '@/pages/inventory/InventoryLedger';
import SuppliersReport from '@/pages/inventory/SuppliersReport';
import DamageEntry from '@/pages/inventory/DamageEntry';

export const inventoryRoutes = (
  <React.Fragment>
    <Route path="inventory/add-stock" element={<AddStock />} />
    <Route path="inventory/issue-stock" element={<IssueStock />} />
    <Route path="inventory/stock-report" element={<StockReport />} />
    <Route path="inventory/stock-use-report" element={<StockUseReport />} />
    <Route path="inventory/suppliers-entry" element={<SuppliersEntry />} />
    <Route path="inventory/purchase-order" element={<PurchaseOrder />} />
    <Route path="inventory/receive-item" element={<ReceiveItem />} />
    <Route path="inventory/pay-suppliers" element={<PaySuppliers />} />
    <Route path="inventory/ledger" element={<InventoryLedger />} />
    <Route path="inventory/suppliers-report" element={<SuppliersReport />} />
    <Route path="inventory/damage-entry" element={<DamageEntry />} />
  </React.Fragment>
);
